import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { store } from 'reduxStore';

export const getMetricsMetadata = () => {
  const accountId = store.getState().accountInfo.id;
  const projectId = store.getState().projectInfo.id;
  return doGet(`${accountId}/${projectId}/metrics`, LOGGER_TYPE.METRICS);
};
